import { SubPageModel } from '../../model/ui/sub-page.model';

const MAX_TABS = 5;
const MORE_TAB_COUNT = 1;
const TAB_PRIORITY = [
  'users',
  'scan-list',
  'lots',
  'orders',
  'videos',
  'patients',
  'results',
  'profile',
  'clinic-info',
];

const getPriority = ({ url }: SubPageModel): number => {
  const index = TAB_PRIORITY.indexOf(url);

  return index === -1 ? TAB_PRIORITY.length : index;
};

export const getMobileNavTabs = (
  subPages: SubPageModel[]
): { tabs: SubPageModel[]; morePages: SubPageModel[] } => {
  const pages = [...subPages].sort((a, b) => getPriority(a) - getPriority(b));

  if (pages.length <= MAX_TABS) {
    return { tabs: pages, morePages: [] };
  }

  const tabCount = MAX_TABS - MORE_TAB_COUNT;

  return { tabs: pages.slice(0, tabCount), morePages: pages.slice(tabCount) };
};
